// Storage bucket holding pasted note screenshots (private; access via signed URLs).
export const NOTE_BUCKET = "note-images";
